import React from 'react';
import useReactRouter from 'use-react-router';
import monkeyLogo from 'assets/monkey-logo@2x.png';
import './OnboardingSidebar.pcss';
import { SIDEBAR_ENTRIES } from '../../../constants';

const OnboardingSidebar = () => {
  const {
    location: { pathname },
  } = useReactRouter();
  const sideBarEntry =
    SIDEBAR_ENTRIES.find(({ routePath }) => routePath === pathname) ||
    SIDEBAR_ENTRIES[0];
  const { img, subtext, text, authorName, authorTitle } = sideBarEntry;

  return (
    <div className="onboarding-sidebar">
      <img
        src={img}
        alt="Onboarding Testimonial Hero"
        className="onboarding-sidebar__image"
      />

      <div className="onboarding-sidebar__image-gradient" />

      <div className="onboarding-sidebar__text-wrapper">
        <div className="onboarding-sidebar__main-text">{text}</div>

        <div className="onboarding-sidebar__quote">&ldquo;</div>

        <div className="onboarding-sidebar__small-text">{subtext}</div>

        <div className="onboarding-sidebar__credits">
          <div className="onboarding-sidebar__name">{authorName}</div>
          <div className="onboarding-sidebar__author-title">{authorTitle}</div>
        </div>
      </div>

      <img
        src={monkeyLogo}
        alt="MobileMonkey Logo"
        className="onboarding-sidebar__logo-image"
      />
    </div>
  );
};

export default OnboardingSidebar;
